import API from "../axiosInstance";

const b2bInvoiceService = {
  uploadInvoice: (formData) =>
    API.post("b2b-invoice", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }),
  searchInvoices: (body) => API.post("b2b-invoice/search", body),
  getInvoice: (invoiceId) => API.get(`b2b-invoice/${invoiceId}`),
  getItemDraft: (itemId) => API.get(`b2b-invoice/item/${itemId}/draft`),
  approveStage: (caseId, stageType) => API.post(`b2b-invoice/approval/${caseId}/stage/${stageType}/approve`),
  sendBackStage: (caseId, stageType, body) =>
    API.post(`b2b-invoice/approval/${caseId}/stage/${stageType}/send-back`, body),
  getInvoicePayment: (invoiceId) => API.get(`b2b-invoice/${invoiceId}/payment`),
  updateInvoicePayment: (invoiceId, body) => API.post(`b2b-invoice/${invoiceId}/payment`, body),
  retriggerInvoicePayment: (invoiceId) => API.post(`b2b-invoice/${invoiceId}/payment/retrigger`),
  manualSuccessInvoicePayment: (invoiceId, body) => API.post(`b2b-invoice/${invoiceId}/payment/manual-success`, body),
  getFilePresignedUrl: (fileUrl) => API.get(`file/preSigned?fileUrl=${encodeURIComponent(fileUrl)}`)
};

export default b2bInvoiceService;
